import { Component, inject } from '@angular/core';
import { GenderService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  GenderCreateDto,
  GenderDto,
  GenderExcelDownloadDto,
  GenderUpdateDto,
} from '../proxy/planning/dtos/gender';
import { GENDER_CONFIG, GENDER_FIELDS } from './gender.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-gender',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, GenderService, ConfirmationService],
  templateUrl: './gender.html',
  styleUrl: './gender.scss',
})
export class Gender extends BaseCrudComponent<
  GenderDto,
  GenderCreateDto,
  GenderUpdateDto,
  GenderExcelDownloadDto
> {
  service = inject(GenderService);
  config = GENDER_CONFIG;
  fields = GENDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: GenderDto): GenderUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Gender';
  }
}
